import getPageName from '../../getPageName';

const initLeavePageModal = () => {
  if (
    getPageName() === 'marketplaces' ||
    getPageName() == 'marketplacebonus' ||
    getPageName() == 'marketplacesbonus' ||
    getPageName() === 'marketplaces-pro' ||
    getPageName() === 'pro-marketplaces' ||
    getPageName() === 'rykovodproject-offer' ||
    getPageName() === 'foreigntradepro-offer' ||
    getPageName() === 'foreigntrade-offer' ||
    getPageName() === 'ai-webinar' ||
    getPageName() === 'webinar' ||
    getPageName() === 'ai-special-offer' || 
    getPageName() === 'ai-special-bonus'
  )
    return;

  let leavePageModal = document.getElementById('leave-page-modal');

  
  if (!leavePageModal) {
    leavePageModal = document.createElement('div');
    leavePageModal.classList.add('appearing-modal', 'custom-modal__hidden');
    //leavePageModal.classList.add('appearing-modal', 'custom-modal__hidden');
    // if (
    //   window.location.pathname === '/program/marketplaces' ||
    //   window.location.pathname === '/program/marketplacesbonus' ||
    //   window.location.pathname === '/program/marketplace' ||
    //   window.location.pathname === '/program/pro-marketplaces'
    // ) {
    //   leavePageModal.classList.add('appearing-modal--form');
    // }

    leavePageModal.id = 'leave-page-modal';
    document.body.append(leavePageModal);
  }

  // if (window.location.pathname === '/program/marketplace') {
  //   leavePageModal.innerHTML = `
  //     <div class="request-pdf green">
  //       <div class="request-pdf__inner">
  //         <div class="request-pdf__left">
  //           <div class="request-pdf__text">
  //             <h3 class="request-pdf__title">Оставьте заявку, наш менеджер свяжется с&nbsp;вами и&nbsp;подробно расскажет о&nbsp;курсе &laquo;Специалист по&nbsp;маркетплейсам&raquo;</h3>
  //           </div>
  //         </div>
  //         <form class="form request-pdf__form" id="form-modal">
  //           <ul class="request-pdf__form-fields">
  //               <li class="form__field">
  //                 <input class="form__input" type="text" name="FirstName" id="name-modal" placeholder="* Имя" maxlength="250">
  //                 <span class="form__required"></span>
  //               </li>
  //               <li class="form__field">
  //                 <input type="tel" id="phone-modal" name="Phone" class="form__input">
  //                 <span class="form__required"></span>
  //               </li>
  //               <li class="form__field">
  //                 <input class="form__input" type="email" name="Email" id="email-modal" placeholder="* Email">
  //                 <span class="form__required"></span>
  //               </li>
  //           </ul>
  //           <input type="hidden" value="-" name="LastName">
  //           <input type="hidden" value="consultation" name="Block">
  //           <input type="hidden" value="Специалист по маркетплейсам" name="Program">
  //           <div class="form__fields">
  //               <div class="form__checkbox">
  //                 <input class="custom-checkbox" type="checkbox" class="agreement" id="personal-data-modal" checked>
  //                 <label class="form__label-check" for="personal-data-modal">
  //                     Я принимаю <a href="/files/privacy_policy.pdf" class="form__politics" target="blank" rel="noopener noreferrer"><span>условия соглашения</span></a>  об обработке персональных данных
  //                 </label>
  //               </div>
  //               <div class="form__checkbox">
  //                 <input class="custom-checkbox" type="checkbox" class="agreement" id="personal-oferta-modal" checked>
  //                 <label class="form__label-check" for="personal-oferta-modal">
  //                     Я принимаю <a href="/files/oferta_file.pdf" class="form__oferta" target="blank" rel="noopener noreferrer"><span>условия публичной оферты</span></a>
  //                 </label>
  //               </div>
  //               <button type="submit" class="btn form__btn" id="submit-modal">Отправить</button>
  //           </div>            
  //         </form>
  //       </div>
  //     </div>
  //   `;

  //   const phoneModal = new Phone({
  //     iti: 'itiPhoneModal',
  //     id: '#phone-modal',
  //   });
  //   phoneModal.setupMaskPhone();

  //   setFormCheckbox(
  //     [
  //       document.querySelector('#personal-data-modal'),
  //       document.querySelector('#personal-oferta-modal'),
  //     ],
  //     document.querySelector('#submit-modal')
  //   );
  //   setForm('#form-modal', phoneModal);
  // } else {
  //   leavePageModal.innerHTML = `
  //     <div class="modal-blackFriday__wrapper">
  //       <div class="modal-blackFriday__text">
  //           <h3>ТАКОЕ БЫВАЕТ РАЗ В ГОДУ!</h3>
  //           <p>Скидки до&nbsp;55% + подарки на&nbsp;сумму до&nbsp;150&nbsp;тыс. руб.</p>
  //           <p>Если вы&nbsp;еще не&nbsp;забронировали место, записывайтесь прямо сейчас, таких цен больше не&nbsp;будет!</p>
  //           <a href="#form" class="btn-blackFriday" data-modal-close>Забронировать</a>
  //       </div>
  //       <div class="modal-blackFriday__img">
  //           <picture>
  //               <source srcset="/img/components/blackFriday/modal/gift.png" media="(min-width: 768px)">
  //               <img src="/img/components/blackFriday/modal/gift-mob.png" loading="lazy" alt="Black Friday">
  //           </picture>
  //       </div>
  //     </div>
  //   `;
  // }
  let finalDate = "16&nbsp;мая";

  if (getPageName() === 'foreigntrade' || getPageName() === 'nutritionist') {
    finalDate = "16&nbsp;мая";
  }

  leavePageModal.innerHTML = `
    <div class="appearing-modal__wrapper">
      <div class="appearing-modal__text">
        <h3>Задержитесь на&nbsp;минуточку 💛</h3>
        <p>Прямо сейчас <span>на все курсы</span> Sigma Academy<br class="d-desk"> действует <span>скидка до&nbsp;50%!</span> Успейте посмотреть все программы и&nbsp;оставить заявку до&nbsp;${finalDate}.</p>
        <h4>Что вас ждет на курсах Sigma&nbsp;Academy:</h4>
        <ul>
          <li>🔥 Профессии и навыки по актуальным направлениям: IT, аналитика и&nbsp;финансы, дизайн, маркетинг, менеджмент, психология и&nbsp;маркетплейсы</li>
          <li>🔥 Онлайн-занятия — можно учиться даже с телефона по 2-3 часа в день</li>
          <li>🔥 Поддержка преподавателей и кураторов 24/7 без VIP-тарифов</li>
          <li>🔥 Портфолио с реальными кейсами и документ об образовании</li>
          <li>🔥 Бесплатная помощь с поиском работы от Центра карьеры</li>
        </ul>
        <a href="#form" class="btn btn--green appearing-modal__link" data-modal-close>Выбрать&nbsp;курс со&nbsp;скидкой до&nbsp;50%</a>
      </div>
      <div class="appearing-modal__img">
        <img src="/img/modals/modal.png" alt="Sale 50%">
      </div>
    </div>
  `;

  
  const forms = document.querySelectorAll('form');
  let statusModal = false;
    
  /* Отключение модального окна при заполнении формы */
  if (forms.length > 0) {
    forms.forEach((form) => {
      form.addEventListener('click', () => {
        statusModal = true;
        removeEventOpenModal();
      });
    });
  }
    
  /* Вывод модального окна при перемещении курсора за пределы сайта */
  const documentLeaveHandle = (evt) => {
    const activeModal = document.querySelector('.custom-modal.active'),
      activeModalJquery = document.querySelector('.jquery-modal');

    if (activeModal || activeModalJquery) return;

    if (!evt.toElement && !evt.relatedTarget) {
      openModalWindow();
    }
  };
    
  /* Вывод моального окна при неактивности более 10 сек */
  let timeout;
  const eventHandlerHiddenElement = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const activeModal = document.querySelector('.custom-modal.active'),
        activeModalJquery = document.querySelector('.jquery-modal');

      if (activeModal || activeModalJquery) return;

      openModalWindow();
    }, 9000);
  };
    
  /* Открытие модального окна */
  function openModalWindow() {
    if (statusModal == true) return;

    statusModal = true;

    const buttonToForm = leavePageModal.querySelector('.appearing-modal__link');
    let btn = document.querySelector('.modal__open');

    if (!btn) {
      btn = document.createElement('button');
      btn.classList.add('modal__open');
      btn.setAttribute('data-modal-id', 'leave-page-modal');
      btn.setAttribute('data-modal-open', '');
      btn.style.display = 'none';

      document.body.append(btn);
    }

    btn.click();
    btn.remove();

    buttonToForm?.addEventListener('click', () => {
      if (!document.querySelector('#form')) {
        window.location.href = '/#form';
      } else {
        document.querySelector('#form').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });

    removeEventOpenModal();
  }

    /* Удаления событий открытия модального окна */
  function removeEventOpenModal() {
    document.removeEventListener('mouseout', documentLeaveHandle);
    document.removeEventListener('mousemove', eventHandlerHiddenElement);
    document.removeEventListener('scroll', eventHandlerHiddenElement);
  }
  
  if (getPageName() !== 'referralprogram') {

    /* Запуск событий */
    setTimeout(() => {
      document.addEventListener('mouseout', documentLeaveHandle);
    }, 30000);

    document.addEventListener('mousemove', eventHandlerHiddenElement);
    document.addEventListener('scroll', eventHandlerHiddenElement);
  }
};

export default initLeavePageModal;
